/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.application.installs.rpc.ApplicationInstallsRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './ApplicationInstallsRpc';
import * as Queries from './ApplicationInstallsRpc.dfc.new';
import type { AdditionalContextArgs } from './ApplicationInstallsRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseUninstallAppMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.UninstallAppResponseType>,
  References.UninstallAppRequestType,
  T extends true
    ? Record<'uninstallApp', References.UninstallAppResponseType>
    : References.UninstallAppResponseType
>;

export function useUninstallAppMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UninstallAppResponseType>,
    References.UninstallAppRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUninstallAppMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UNINSTALL_APP_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            uninstallApp: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUninstallAppMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUninstallAppMutationReturn<T>;
}

type UseDeleteAccountMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.DeleteAccountResponseType>,
  References.DeleteAccountRequestType,
  T extends true
    ? Record<'deleteAccount', References.DeleteAccountResponseType>
    : References.DeleteAccountResponseType
>;

export function useDeleteAccountMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DeleteAccountResponseType>,
    References.DeleteAccountRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDeleteAccountMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DELETE_ACCOUNT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            deleteAccount: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDeleteAccountMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDeleteAccountMutationReturn<T>;
}

type UseGetUserInstallInfosQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetUserInstallInfosResponseType>,
    References.GetUserInstallInfosRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getUserInstallInfos',
            References.GetUserInstallInfosResponseType
          >
        : References.GetUserInstallInfosResponseType)
    | undefined;
};

export function useGetUserInstallInfosQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetUserInstallInfosResponseType>,
    References.GetUserInstallInfosRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserInstallInfosQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_USER_INSTALL_INFOS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUserInstallInfos: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUserInstallInfosQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetUserInstallInfosQueryReturn<T>;
}

type UseGetUserInstallInfosLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetUserInstallInfosResponseType>,
    References.GetUserInstallInfosRequestType,
    T extends true
      ? Record<
          'getUserInstallInfos',
          References.GetUserInstallInfosResponseType
        >
      : References.GetUserInstallInfosResponseType
  >;

export function useGetUserInstallInfosLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetUserInstallInfosResponseType>,
    References.GetUserInstallInfosRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserInstallInfosLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_USER_INSTALL_INFOS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUserInstallInfos: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetUserInstallInfosLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetUserInstallInfosLazyQueryReturn<T>;
}

type UseGetUserInstallInfosSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetUserInstallInfosResponseType>,
    References.GetUserInstallInfosRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getUserInstallInfos', References.GetUserInstallInfosResponseType>
    : References.GetUserInstallInfosResponseType;
};

export function useGetUserInstallInfosSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetUserInstallInfosResponseType>,
    References.GetUserInstallInfosRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserInstallInfosSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_USER_INSTALL_INFOS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getUserInstallInfos: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUserInstallInfosSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetUserInstallInfosSuspenseQueryReturn<T>;
}

type UseUninstallAppForUserMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UninstallAppForUserResponseType>,
    References.UninstallAppForUserRequestType,
    T extends true
      ? Record<
          'uninstallAppForUser',
          References.UninstallAppForUserResponseType
        >
      : References.UninstallAppForUserResponseType
  >;

export function useUninstallAppForUserMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UninstallAppForUserResponseType>,
    References.UninstallAppForUserRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUninstallAppForUserMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UNINSTALL_APP_FOR_USER_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            uninstallAppForUser: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUninstallAppForUserMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUninstallAppForUserMutationReturn<T>;
}

type UseGetInstalledAppsWithAppPermissionsForDataClassificationQueryReturn<
  T extends boolean,
> = Omit<
  QueryResult<
    Record<
      'result',
      References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType
    >,
    References.GetInstalledAppsWithAppPermissionsForDataClassificationRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getInstalledAppsWithAppPermissionsForDataClassification',
            References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType
          >
        : References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType)
    | undefined;
};

export function useGetInstalledAppsWithAppPermissionsForDataClassificationQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<
      'result',
      References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType
    >,
    References.GetInstalledAppsWithAppPermissionsForDataClassificationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstalledAppsWithAppPermissionsForDataClassificationQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_INSTALLED_APPS_WITH_APP_PERMISSIONS_FOR_DATA_CLASSIFICATION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstalledAppsWithAppPermissionsForDataClassification:
              data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstalledAppsWithAppPermissionsForDataClassificationQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstalledAppsWithAppPermissionsForDataClassificationQueryReturn<T>;
}

type UseGetInstalledAppsWithAppPermissionsForDataClassificationLazyQueryReturn<
  T extends boolean,
> = LazyQueryResultTupleOverride<
  Record<
    'result',
    References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType
  >,
  References.GetInstalledAppsWithAppPermissionsForDataClassificationRequestType,
  T extends true
    ? Record<
        'getInstalledAppsWithAppPermissionsForDataClassification',
        References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType
      >
    : References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType
>;

export function useGetInstalledAppsWithAppPermissionsForDataClassificationLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<
      'result',
      References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType
    >,
    References.GetInstalledAppsWithAppPermissionsForDataClassificationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstalledAppsWithAppPermissionsForDataClassificationLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_INSTALLED_APPS_WITH_APP_PERMISSIONS_FOR_DATA_CLASSIFICATION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstalledAppsWithAppPermissionsForDataClassification:
              data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetInstalledAppsWithAppPermissionsForDataClassificationLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetInstalledAppsWithAppPermissionsForDataClassificationLazyQueryReturn<T>;
}

type UseGetInstalledAppsWithAppPermissionsForDataClassificationSuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<
      'result',
      References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType
    >,
    References.GetInstalledAppsWithAppPermissionsForDataClassificationRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getInstalledAppsWithAppPermissionsForDataClassification',
        References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType
      >
    : References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType;
};

export function useGetInstalledAppsWithAppPermissionsForDataClassificationSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<
      'result',
      References.GetInstalledAppsWithAppPermissionsForDataClassificationResponseType
    >,
    References.GetInstalledAppsWithAppPermissionsForDataClassificationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstalledAppsWithAppPermissionsForDataClassificationSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_INSTALLED_APPS_WITH_APP_PERMISSIONS_FOR_DATA_CLASSIFICATION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getInstalledAppsWithAppPermissionsForDataClassification:
              data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstalledAppsWithAppPermissionsForDataClassificationSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstalledAppsWithAppPermissionsForDataClassificationSuspenseQueryReturn<T>;
}
